import {
  SET_UNSAVED_FLAG,
  SET_APP_STATE_INITIAL,
  SET_COMPANY_DATA,
  SET_PROJECT_DETAIL,
  SET_APP_IS_LOADING,
  SET_APP_ERROR,
  SET_DATA_SETTINGS,
  SET_VIEW_ALL_SECTIONS_ENABLED,
  SET_COMPANY_DATA_VALID,
  SET_REPORT_IS_LOADING,
} from "./mutations";
import {generateForecastRC} from "../forecastRC/actions";
import {generateForecastedGWC} from "../forecastGWC/actions";
import {
  generateAssetSaleDealSplitReport, generateAssetSaleProceedsWorksheet,
  generateCurrentCompanyBalanceSheetReport,
  generateGoodwillReport, generateOwnerFinancingStockSaleReport,
  generateReconciliationOfValuationMethodsReport,
  generateStockDealSplitReport,
  // setCurrentCompanyBalanceSheet,
  setReconciliationOfValuationMethodsReport
} from "../financials/actions";
import {store} from "../../index";

const setAppIsLoading = (payload) => ({
  type: SET_APP_IS_LOADING,
  payload,
});

const setAppError = (payload) => ({
  type: SET_APP_ERROR,
  payload,
});

const setUnsavedFlag = (payload) => ({
  type: SET_UNSAVED_FLAG,
  payload,
});

const setAppInitialState = (payload) => ({
  type: SET_APP_STATE_INITIAL,
  payload,
});

const setCompanyData = (payload) => ({
  type: SET_COMPANY_DATA,
  payload,
});

const setProjectDetail = (payload) => ({
  type: SET_PROJECT_DETAIL,
  payload,
});

const setDataSettings = (payload) => ({
  type: SET_DATA_SETTINGS,
  payload,
});

const setViewAllSectionsEnabled = (enable) => dispatch =>  {
  dispatch({ type: SET_VIEW_ALL_SECTIONS_ENABLED, payload: enable })
}

const runCompanyDataValidation = () => (dispatch) => {
  const {
    currentCompanyMonthlyBalanceSheet,
    currentCompanyMonthlyProfitAndLoss,
  } = store.getState().financials

  let companyDataValid = "true";
  if(!currentCompanyMonthlyBalanceSheet || !currentCompanyMonthlyProfitAndLoss) companyDataValid = "false";

  // disabled empty data validation temporarily
  // if(
  //   currentCompanyMonthlyBalanceSheet?.assets[0].items?.length + currentCompanyMonthlyBalanceSheet?.liabilities[0].items?.length === 0 ||
  //   currentCompanyMonthlyProfitAndLoss?.incomes?.length + currentCompanyMonthlyProfitAndLoss?.otherIncomes?.length + 
  //     currentCompanyMonthlyProfitAndLoss?.expenses?.length + currentCompanyMonthlyProfitAndLoss?.otherExpenses?.length === 0
  // ) companyDataValid = "empty";   //empty means it has no detailed data

  dispatch({ type: SET_COMPANY_DATA_VALID, payload: companyDataValid })
}

const setReportIsLoading = (payload) => ({
  type: SET_REPORT_IS_LOADING,
  payload,
});

const generateInitialData = () => dispatch => {
  dispatch(generateForecastRC())
  dispatch(generateForecastedGWC())
  // dispatch(setCurrentCompanyBalanceSheet())
  dispatch(generateCurrentCompanyBalanceSheetReport())
  dispatch(setReconciliationOfValuationMethodsReport())
  dispatch(generateReconciliationOfValuationMethodsReport())
  dispatch(generateGoodwillReport())
  dispatch(generateStockDealSplitReport())
  dispatch(generateAssetSaleDealSplitReport())
  dispatch(generateOwnerFinancingStockSaleReport())
  dispatch(generateAssetSaleProceedsWorksheet())
}

export {
  setUnsavedFlag,
  setAppInitialState,
  setCompanyData,
  setProjectDetail,
  setAppIsLoading,
  setAppError,
  setDataSettings,
  setViewAllSectionsEnabled,
  generateInitialData,
  runCompanyDataValidation,
  setReportIsLoading
};
